import {
    $, addAction, doAction, LAYOUT,
} from '@situation/setdesign.util';
import NavButton from './NavButton';
import NavItem from './NavItem';
import NavRail from './NavRail';

class NavSlider {
    constructor($container) {
        this.current = 0;
        this.top = 0;
        this.engaged = false;
        this.ariaControlsSet = false;
        this.$el = $container;
        this.$container = this.$el.find('.home-slider__nav__items');
        this.$highlight = $container.find('.home-slider__nav__active');
        this.rail = new NavRail(this.$el.find('.home-slider__nav__items__rail'), this.$highlight);
        this.items = $container
            .find('.home-slider__nav-item')
            .map((index, element) => new NavItem($(element), index))
            .get();

        this.buttons = $container
            .find('.home-slider__nav__btn')
            .map((index, element) => new NavButton($(element), index))
            .get();

        this.handleMouseenter = () => {
            doAction('home-carousel/pause');
        };

        this.handleMouseleave = () => {
            if (!this.engaged) {
                doAction('home-carousel/resume');
            }
        };

        this.handleClick = () => {
            this.engaged = true;
            doAction('home-carousel/pause');
        };

        this.$el.on('mouseenter', this.handleMouseenter);
        this.$el.on('mouseleave', this.handleMouseleave);
        this.$el.on('focusin click', this.handleClick);
        addAction(LAYOUT, this.setItemHeight, 20, this);
        addAction('home-carousel/change', this.change, 10, this);
        addAction('home-carousel/paginate', this.paginate, 10, this);
    }

    setItemHeight() {
        this.applyToItems('resize', [0]);
        this.applyToItems('clamp');
        setTimeout(() => {
            const height = this.$highlight.outerHeight();
            this.applyToItems('resize', [height]);
            this.rail.goto(this.top, this.current);
            this.$container.removeClass('home-slider__nav__items--loading');
        }, 500);
    }

    change(index) {
        // Set aria-controls on first change event (after carousel fully initialized)
        if (!this.ariaControlsSet) {
            this.setAriaControls();
            this.ariaControlsSet = true;
        }

        this.current = index;
        const max = this.items.length - 3;
        const diff = this.current - this.top;
        if (diff > 2) {
            this.top = this.current > max ? max : this.current;
        } else if (diff < 0) {
            this.top = this.current - 2;
        }
        if (this.top < 0) {
            this.top = 0;
        }

        this.applyToItems('select', [this.current, this.top]);
        this.rail.goto(this.top, this.current);
    }

    paginate(count) {
        const selected = (this.current + count + this.items.length) % this.items.length;
        // Will leave this here in case we restore pagination on arrows
        /* if(this.top === 0 && count < 0) {
            selected = this.items.length - 1;
        }
        */
        doAction('home-carousel/goto', selected);
    }

    applyToItems(method, args) {
        const argsArray = Array.isArray(args) ? args : [args];
        this.items.forEach((item) => {
            item[method](...argsArray);
        });
    }

    setAriaControls() {
        const $carousel = $('.home-slider__main');
        if (!$carousel.length) {
            console.warn('HomeSlider: Carousel element not found');
            return;
        }

        // Get non-cloned slides with IDs set by Owl2A11y plugin
        const $slides = $carousel.find('.owl-stage .owl-item').not('.cloned').filter('[id^="owl-a11y-panel-"]');
        if ($slides.length === 0) {
            console.warn('HomeSlider: No slides found after carousel init');
            return;
        }
        if ($slides.length !== this.items.length) {
            console.warn(`HomeSlider: Slide count (${$slides.length}) !== nav item count (${this.items.length})`);
        }

        // Map each nav item to its corresponding slide panel
        this.items.forEach((navItem, index) => {
            const $slide = $slides.eq(index);
            if ($slide.length && $slide.attr('id')) {
                navItem.$el.attr('aria-controls', $slide.attr('id'));
            }
        });
    }
}

export default NavSlider;
